import React from "react";
import { getInitial } from "../../services/utils/name-utils";
import TimeTableWeekEvents from "./Time-table-week-events";
import "../../styles/weekEvents.css";
import { Tooltip } from "@mui/material";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import { shortenParagraph } from "../../../utils/Engagement";
import TimeTableJoinNow from "../day-event/Time-table-join-now";

const TimeTableWeekEvent = ({ event }) => {
  if (!event) return null;
  const currentTime = new Date();
  const eventStartTime = new Date(event?.StartTime);
  const eventEndTime = new Date(event?.EndTime);
  const hasLiveSession = event.Events?.some((e) => e.name === "bbb_lecture");

  const diff = Math.abs(
    event?.EndTime?.getTime() - event?.StartTime?.getTime(),
  );
  const minutes = Math.round(diff / 60000);

  const now = Date.now();
  const isHappened = currentTime.getTime() > eventEndTime.getTime();
  const isEventHappening =
    currentTime.getTime() >= eventStartTime.getTime() &&
    currentTime.getTime() <= eventEndTime.getTime();
  console.log("Event in week", event);
  /* ================= CENTER STACK ================= */
  const CenterStack = () => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 6,
        marginTop: 6,
      }}
    >
      {/* Live Icon */}
      {/* {hasLiveSession && <LiveTvIcon color="error" fontSize="small" />} */}

      {/* Join Now */}
      {/* {event.Events[0] !== "Planner" &&
        event.lectureType !== "general_category" &&
        isEventHappening && <TimeTableJoinNow event={event} />} */}
    </div>
  );
  console.log("isHappened in week");
  /* ================= SUBJECT + INITIAL ROW ================= */
  const HeaderRow = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
      }}
    >
      {/* SUBJECT */}
      <div style={{ maxWidth: "75%" }}>
        {event.lectureType === "general_category" &&
        event.Events[0] !== "Planner" ? (
          <Tooltip title={event.lectureName.toUpperCase()} arrow>
            <div className="weekStyle">{event.lectureName.toUpperCase()}</div>
          </Tooltip>
        ) : (
          <Tooltip title={event.Subject} arrow>
            <div className="sbj1">{shortenParagraph(event.Subject, 18)}</div>
          </Tooltip>
        )}
      </div>

      {/* TEACHER INITIAL */}
      {event?.Teacher?.name && (
        <Tooltip title={event.Teacher.name} arrow>
          <div className="crcl">
            <span className="inti">{getInitial(event.Teacher.name)}</span>
          </div>
        </Tooltip>
      )}
    </div>
  );

  /* ================= SHORT EVENT (≤30 MIN) ================= */
  if (minutes <= 30) {
    return (
      <div className="week-template-wrap">
        <div className="flex flex-col gap-1">
          {/* HEADER ROW */}
          <HeaderRow />

          {/* Planner */}
          {event.Events[0] === "Planner" && (
            <div
              className="text-xs font-medium"
              style={{ color: event.DisplayColor }}
            >
              Study Planner
            </div>
          )}

          {/* CENTER STACK */}
          {/* <CenterStack /> */}
          <div className="d-flex flex-row align-items-center gap-2 ">
            {event.lectureType !== "general_category" &&
              !event.bbb_lecture_id &&
              event.Events[0] !== "Planner" && (
                <span style={{ fontSize: "16px" }}>🏫</span>
              )}

            {event.lectureType !== "general_category" &&
              event.bbb_lecture_id &&
              event.Events[0] !== "Planner" && (
                <span style={{ fontSize: "16px" }}>💻</span>
              )}

            {event.Events[0] !== "Planner" &&
              event.lectureType !== "general_category" && (
                <>
                  {isEventHappening && <span>🟢</span>}
                  {!isEventHappening && !isHappened && <span>⏳</span>}
                  {isHappened && <span>✅</span>}
                </>
              )}

            <div className="flex">
              <TimeTableWeekEvents event={event} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  /* ================= LONG EVENT (>30 MIN) ================= */
  return (
    <div className="week-template-wrap w-full">
      <div className="container mx-auto px-2">
        <div className="flex flex-col gap-2">
          {/* HEADER ROW */}
          <HeaderRow />

          {/* Planner */}
          {event.Events[0] === "Planner" && (
            <div className="text-center">
              <div className="lectype" style={{ color: event.DisplayColor }}>
                Study Planner
              </div>
              <div className="sbj2" style={{ color: event.DisplayColor }}>
                {event.Subject}
              </div>
            </div>
          )}

          {/* CENTER STACK */}
          {/* <CenterStack /> */}
          <div className="d-flex flex-row align-items-center gap-2 ">
            {event.lectureType !== "general_category" &&
              !event.bbb_lecture_id &&
              event.Events[0] !== "Planner" && (
                <span style={{ fontSize: "16px" }}>🏫</span>
              )}

            {event.lectureType !== "general_category" &&
              event.bbb_lecture_id &&
              event.Events[0] !== "Planner" && (
                <span style={{ fontSize: "16px" }}>💻</span>
              )}

           {event.Events[0] !== "Planner" &&
              event.lectureType !== "general_category" && (
                <>
                  {isEventHappening && <span>🟢</span>}
                  {!isEventHappening && !isHappened && <span>⏳</span>}
                  {isHappened && <span>✅</span>}
                </>
              )}

            <div className="flex justify-center">
              <TimeTableWeekEvents event={event} />
            </div>
          </div>

          {/* TIME */}
          {/* <div className="flex justify-center">
         
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default TimeTableWeekEvent;
